import { createSelector, createSlice } from "@reduxjs/toolkit";
import { createBaseSelector, registerSlice } from "shared/lib/redux";

type UpdateAllCardsModal = boolean;

const initialUpdateAllCardsModal: UpdateAllCardsModal = false;

const updateAllCardsModalSlice = createSlice({
  name: "updateAllCardsModal",
  initialState: initialUpdateAllCardsModal,
  reducers: {
    openUpdateAllCardsModalAction: () => {
      return true;
    },
    closeUpdateAllCardsModalAction: () => {
      return false;
    },
  },
});

const appBaseSelector = createBaseSelector(updateAllCardsModalSlice);

registerSlice([updateAllCardsModalSlice]);

export const updateAllCardsModalStore = {
  actions: updateAllCardsModalSlice.actions,
  selectors: {
    isUpdateAllCardsModalOpened: createSelector(appBaseSelector, (s) => s),
  },
};
